import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import NominaCatalogoManager from '../../../../catalogs/managers/NominaCatalogoManager';

class ComplementoNominaGeneralInfo extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    return {
      TipoNomina: ['required', 'string', 'in:O,E'],
      FechaPago: [
        'required',
        // 'regex:/^[0-9]{2}/[0-9]{2}/[0-9]{4}$/'
      ],
      FechaInicialPago: [
        'required',
        // 'regex:/^[0-9]{2}/[0-9]{2}/[0-9]{4}$/'
      ],
      FechaFinalPago: [
        'required',
        // 'regex:/^[0-9]{2}/[0-9]{2}/[0-9]{4}$/'
      ],
      NumDiasPagados: [
        'required',
        'decimal:3',
        'min:0.001',
        'max:36160.000',
        'regex:/^(([1-9][0-9]{0,4})|[0])(.[0-9]{3})?$/',
      ],
      TotalPercepciones: ['decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      TotalDeducciones: ['decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      TotalOtrosPagos: ['decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
    };
  }

  async componentDidMount() {
    try {
      await NominaCatalogoManager.boot();

      let catalogos = {};

      catalogos.tipoNomina = [
        {
          label: 'Selecciona',
          value: '',
        },
      ].concat(
        NominaCatalogoManager.get('c_nom_tipo_nomina').map((item) => {
          return {
            label: item.descripcion,
            value: item.tipo,
          };
        })
      );

      this.setState({
        catalogos,
      });
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        message: error.message || 'Error recuperando catálogo de nómina',
      });
    }
  }

  validate = (data) => {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  };

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value,
    };

    const validator = this.validate(data);

    this.props.onChange({
      data,
      isValid: validator.passes(),
    });
  };

  render() {
    const rules = this.rules;
    const { catalogos = {} } = this.state;
    const { data = {} } = this.props;

    return (
      <div className="pb-4">
        <div className="section pt-2">
          <Row>
            <Col
              sm
              md={4}
            >
              <FormControl
                type="select"
                label="Tipo Nómina"
                name="TipoNomina"
                placeholder=""
                help=""
                rules={rules.TipoNomina}
                value={data.TipoNomina}
                options={catalogos ? catalogos.tipoNomina : []}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="date-picker"
                id="FechaPago"
                label="Fecha Pago"
                name="FechaPago"
                placeholder=""
                help=""
                rules={rules.FechaPago}
                value={data.FechaPago}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="date-picker"
                id="FechaInicialPago"
                label="Fecha Inicial Pago"
                name="FechaInicialPago"
                placeholder=""
                help=""
                rules={rules.FechaInicialPago}
                value={data.FechaInicialPago}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="date-picker"
                id="FechaFinalPago"
                label="Fecha Final Pago"
                name="FechaFinalPago"
                placeholder=""
                help=""
                rules={rules.FechaFinalPago}
                value={data.FechaFinalPago}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="text"
                label="Número Días Pagados"
                name="NumDiasPagados"
                placeholder=""
                help=""
                rules={rules.NumDiasPagados}
                value={data.NumDiasPagados}
                onChange={this.handleOnChange}
              />
            </Col>
          </Row>

          <Row>
            <Col
              sm
              md={4}
            >
              <FormControl
                type="text"
                label="Total Percepciones"
                name="TotalPercepciones"
                placeholder=""
                help=""
                rules={rules.TotalPercepciones}
                value={data.TotalPercepciones || 0}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="text"
                label="Total Deducciones"
                name="TotalDeducciones"
                placeholder=""
                help=""
                rules={rules.TotalDeducciones}
                value={data.TotalDeducciones || 0}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="text"
                label="Total Otros Pagos"
                name="TotalOtrosPagos"
                placeholder=""
                help=""
                rules={rules.TotalOtrosPagos}
                value={data.TotalOtrosPagos || 0}
                onChange={this.handleOnChange}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <p className="text-muted">Los totales serán calculados automáticamente</p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default ComplementoNominaGeneralInfo;
